import React, { useRef } from 'react';
import { graphql } from "gatsby"
import * as styles from "./HiveEntryForm.css"
import '../../../static/hive.css';

export type HiveEntryFormProps = {
    hiveformid?: number
    successmessageheader?: string
    successmessagebody?: string
    buttontext?: string,
    suffixtext?: string,
    prefacetext?: string,
}

export default function HiveEntryForm({
        hiveformid = 6211,
        successmessageheader = 'Thanks!',
        successmessagebody = 'You\'ve been successfully subscribed.',
        buttontext = 'Subscribe',
        prefacetext = ''
    }: HiveEntryFormProps) {
  
    const formRef = useRef(null);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (window.HIVE_SDK && typeof window.HIVE_SDK === 'function' && formRef.current) {
            window.HIVE_SDK('submitSignupForm', formRef.current, onFormSubmitSuccess);
        }
    };

  const onFormSubmitSuccess = () => {
    console.log('Form submitted successfully');
  };

  return (
    <div className={styles.formContainer}>
        {( prefacetext ? <div className={styles.prefaceText}>{prefacetext}</div> : null )}
        <div className={styles.formWrapper}>
            <form ref={formRef} onSubmit={handleSubmit} className={styles.form}>
                <input data-hive-form-field="swid" type="hidden" value={hiveformid ?? ""} />
                <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">
                    <input type="text" data-hive-form-field="areUReal" tabIndex={-1}  defaultValue=""/>
                </div>

                <div data-hive-form-field="successMessage" style={{display: 'none'}}>
                    <h2>{successmessageheader}</h2>
                    <p>{successmessagebody}</p>
                </div>
                <input 
                    className="email-field" 
                    data-hive-form-field="email"  
                    id={`_HIVE-email-${hiveformid}`}
                    name="email"
                    type="email"
                    defaultValue=""
                    placeholder="Your email" 
                    autoComplete="email" required />
            <button type="submit">{buttontext}</button>
            </form>
        </div>
    </div>
  );
};

export const query = graphql`
  fragment HiveEntryFormContent on HiveEntryForm {
    hiveformid
    successmessageheader
    successmessagebody
    buttontext
    prefacetext
    suffixtext
  }
`